import { useState } from "react";
import { Label } from "@/components/site/forms";

const rnd = () => Math.floor(Math.random() * 7) + 2;

// Lightweight spam protection: an invisible honeypot (bots fill it) plus a
// human math challenge that must be solved before a form can be submitted.
export const HumanCheck = ({ onChange, id = "human-check" }) => {
  const [a] = useState(rnd);
  const [b] = useState(rnd);
  const [answer, setAnswer] = useState("");
  const [hp, setHp] = useState("");

  const emit = (ans, honey) => onChange({ valid: parseInt(ans, 10) === a + b, honeypot: honey });

  return (
    <div>
      <input
        type="text"
        name="company_website"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        value={hp}
        onChange={(e) => {
          setHp(e.target.value);
          emit(answer, e.target.value);
        }}
        className="pointer-events-none absolute left-[-9999px] top-0 h-0 w-0 opacity-0"
      />
      <Label htmlFor={id}>Spam check — what is {a} + {b}?</Label>
      <input
        id={id}
        data-testid="field-human-check"
        inputMode="numeric"
        value={answer}
        onChange={(e) => {
          setAnswer(e.target.value);
          emit(e.target.value, hp);
        }}
        placeholder="Answer"
        className="w-40 border border-white/12 bg-white/[0.02] px-4 py-3 text-[15px] text-bone placeholder:text-mist/60 outline-none transition-colors duration-300 focus:border-saffron"
      />
    </div>
  );
};
